import { IEntry } from 'shared/models/sheet/Sheet';
import { ISheetsGridFilters } from 'store/components/workingSheets/workingSheetsModel';

export function filterEntryByKeys(
    filters: ISheetsGridFilters, entry: IEntry, keys: Array<keyof Omit<ISheetsGridFilters, 'area_id'>>,
): boolean {
    // @ts-ignore
    return !keys.some(key => filters[key] && entry[key] !== filters[key]);
}
